import { action } from '@reatom/framework'

import { reatomBackOfficeWalletRefreshBalanceRequestAction } from '@root/entities/back-office/atoms/reatom-back-office-wallet-refresh-request-action'
import { reatomRequest } from '@root/shared/lib'

import type { DelugeId } from '@root/entities/user-short'
import type { WalletId } from '@root/entities/wallet'

interface BackOfficeWalletRefreshBalancePayload {
  delugeId: DelugeId
  walletId: WalletId
}

export const reatomBackOfficeWalletRefreshBalanceModel = (
  data: BackOfficeWalletRefreshBalancePayload,
) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  return reatomRequest({
    // eslint-disable-next-line @reatom/unit-naming-rule
    execAction: action((ctx) =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomBackOfficeWalletRefreshBalanceRequestAction(ctx, data),
    ),
  })
}
